import * as React from "react"
import { Button, FormControlLabel, Radio, RadioGroup, TextField, ThemeProvider, makeStyles } from "@material-ui/core"
import { tl } from "../../../utils";
import classNames from "classnames";
import api from "../../../api";
import { MUIPhoneInput, Theme } from "../MUI";
import CountdownTimer from "../../../components/CountdownTimer";

export const WelcomePage: React.FC = () => {
  const classes = useStyles();
  const [step, setStep] = React.useState<TPhoneStepCheck>('check');
  const [code, setCode] = React.useState<string>('');
  const [retryTimeout, setRetryTimeout] = React.useState<number>(60);
  const [showTimer, setShowTimer] = React.useState<boolean>(false);
  const [codeError, setCodeError] = React.useState<boolean>(false);
  const [startConfirmationError, setStartConfirmationError] = React.useState<boolean>(false);
  const [telegramConfirmationError, setTelegramConfirmationError] = React.useState<boolean>(false);
  const [quiz, setQuiz] = React.useState({
    clientType: '',
    contact: 'call',
    phone: '',
    username: '',
  });
  const [showSkip, setShowSkip] = React.useState<boolean>(false);
  setTimeout(() => setShowSkip(true), 60000)

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setQuiz(prevState => ({
      ...prevState,
      [name]: value
    }));

  };

  const handleStartConfirmation = async () => {
    try {
      // Существует три способа подтверждения, для каждого свой вариант подтверждения
      setStartConfirmationError(false);
      switch (quiz['contact']) {
        case 'call':
          const phoneResponse = await api.phones.welcomeCheck(quiz['phone']);
          if (phoneResponse && phoneResponse.retryTimeout) {
            setRetryTimeout(phoneResponse.retryTimeout);
            setShowTimer(true);
            setStep('confirm');
          }
          break;
        case 'whatsapp':
          const whatsappResponse = await api.whatsapp.check(quiz['phone']);
          if (whatsappResponse) {
            setRetryTimeout(60);
            setShowTimer(true);
            setStep('confirm');
          }
          break;
        case 'telegram':
          window.open('/telegram', '_blank');
          setStep('confirm');
          break;
        default:
          break;
      }

    } catch (error) {
      setStartConfirmationError(true);
    }
  }

  const handleFormWithoutPhone = async () => {
    try {
      let redirectUri = '/panel/courses?pmessage=authorregdone&link_source=registration';
      redirectUri = await api.user.welcome(quiz);
      window.location.href = redirectUri;
    } catch (error) {
      console.log(error);
    }
  }

  const handleConfirmTelegram = async (e: React.FormEvent) => {
    try {
      setTelegramConfirmationError(false);
      const response = await api.profile.byId();
      if (response?.userProfile?.telegram?.id) {
        if (quiz['clientType'] === 'student' && window.dataLayer) {
          window.dataLayer.push({
            'event': 'welcomeEvent',
            'eventId': `welcome-${window._user_id}`
          })
        }

        let redirectUri = '/panel/courses?pmessage=authorregdone&link_source=registration';
        redirectUri = await api.user.welcome(quiz);
        window.location.href = redirectUri;
      } else {
        setTelegramConfirmationError(true);
      }
    } catch (error) {
      setTelegramConfirmationError(true);
    }
  }

  const handleForm = async (e: React.FormEvent) => {
    e.preventDefault();
    if (quiz['clientType'] === 'student' && window.dataLayer) {
      window.dataLayer.push({
        'event': 'welcomeEvent',
        'eventId': `welcome-${window._user_id}`
      })
    }
    try {
      const response = await api.phones.confirm(quiz['phone'], code);
      if (response && !response.retryTimeout) {
        let redirectUri = '/panel/courses?pmessage=authorregdone&link_source=registration';
        redirectUri = await api.user.welcome(quiz);
        window.location.href = redirectUri;
      }
    } catch (error) {
      setCodeError(true);
    }
  }

  return (
    <form className={classes.root} onSubmit={handleForm}>
      <div className={classNames(classes.videoBlock, classes.roundedBlock, classes.boxPadding1)}>
        <div className={classes.videoDescription}>
          <h3 className={classes.h2}>{tl('Добро пожаловать на Антитренинги!')}</h3>
          <p>{tl('Спасибо за регистрацию. В течение следующих 15 минут (в рабочее время) с Вами свяжется специалист нашей платформы. А пока можно посмотреть наш первый курс. Он расскажет Вам о платформе, её возможностях и популярных инструментах. Приятного знакомства с Антитренингами!')}</p>
        </div>
      </div>
      <div className={classes.surveyColumns}>
        <div className={classNames(classes.roundedBlock, classes.boxPadding2)}>
          <h3 className={classes.h3}>{tl('Зачем вам Антитренинги?')}</h3>
          <div>
            <RadioGroup
              name="clientType"
              className={classes.radioGroup}
              value={quiz.clientType}
              onChange={handleChange}
              aria-required
            >
              <FormControlLabel
                label={tl('Хочу создать онлайн-школу, есть готовые материалы для обучения')}
                classes={{
                  label: classes.radioLabel
                }}
                control={<Radio color="primary" value="client" disabled={step === 'confirm'} />}
                data-testid="client"
              />
              <FormControlLabel
                label={tl('Есть онлайн-школа на другой платформе, хочу изучить АнтиТренинги')}
                classes={{
                  label: classes.radioLabel
                }}
                control={<Radio color="primary" value="other-platform" disabled={step === 'confirm'} />}
                data-testid="otherPlatform"
              />
              <FormControlLabel
                label={tl('Я — администратор / тех. специалист / наставник онлайн-школы, хочу изучить платформу')}
                classes={{
                  label: classes.radioLabel
                }}
                control={<Radio color="primary" value="admin" disabled={step === 'confirm'} />}
                data-testid="admin"
              />
              <FormControlLabel
                label={tl('Ранее не обучал, но хочу посмотреть как работает платформа')}
                classes={{
                  label: classes.radioLabel
                }}
                control={<Radio color="primary" value="potential-client" disabled={step === 'confirm'} />}
                data-testid="potentialClient"
              />
              <FormControlLabel
                label={tl('Я — ученик и не планирую обучать сам')}
                classes={{
                  label: classes.radioLabel
                }}
                control={<Radio color="primary" value="student" disabled={step === 'confirm'} />}
                data-testid="student"
              />
            </RadioGroup>
          </div>
        </div>
        <div className={classNames(classes.roundedBlock, classes.boxPadding2)}>
          <h3 className={classes.h3}>{tl('Способ верификации')}</h3>
          <div>
            <RadioGroup
                value={quiz.contact}
                name="contact"
                className={classes.radioGroup}
                onChange={handleChange}
                aria-required
            >
              <div className={classes.radioLabelContainer}>
                <FormControlLabel
                  label={tl('По телефону')}
                  classes={{
                    label: classes.radioLabel
                  }}
                  control={<Radio color="primary" value="call" disabled={step === 'confirm'} />}
                  data-testid="call"
                />
              </div>
              <div className={classes.radioLabelContainer}>
                <FormControlLabel
                  label={tl('WhatsApp')}
                  classes={{
                    label: classes.radioLabel
                  }}
                  control={<Radio color="primary" value="whatsapp" disabled={step === 'confirm'} />}
                  data-testid="whatsapp"
                />
              </div>
              <div className={classes.radioLabelContainer}>
                <FormControlLabel
                  label={tl('Telegram')}
                  classes={{
                    label: classes.radioLabel
                  }}
                  control={<Radio color="primary" value="telegram" disabled={step === 'confirm'} />}
                  data-testid="telegram"
                />
              </div>
            </RadioGroup>
          </div>
        </div>
      </div>
      <div className={classNames(classes.roundedBlock, classes.phoneSection)}>
        {step === 'check' &&
          <>
          {(quiz['contact'] === 'call' || quiz['contact'] === 'whatsapp') &&
            <h3 className={classes.h3}>{tl('Пожалуйста, введите свой номер телефона чтобы продолжить')}</h3>
          }
          {quiz['contact'] === 'telegram' &&
             <h3 className={classes.h3}>{tl('Пожалуйста, свяжитесь с нашим ботом в Телеграм')}</h3>
          }
          <p className={classes.p}>{tl('Так мы сможем убедиться, что вы реальный человек и предоставить вам персонального менеджера, который познакомит со всеми возможностями платформы')}</p>
          <div className={classes.phoneContainer}>
            <div className={classes.phoneBlock}>
              {(quiz['contact'] === 'call' || quiz['contact'] === 'whatsapp') &&
                <div className={classes.phone}>
                  <MUIPhoneInput
                    withoutPadding
                    variant="outlined"
                    color="primary"
                    fullWidth
                    onChange={(phoneData) => {
                      setQuiz(prevState => ({
                        ...prevState,
                        phone: phoneData.value,
                      }));
                    }}
                  />
                </div>
              }
              <Button 
                id="send-sms"
                type="button"
                className={classes.rowFormBtn}
                variant="contained"
                color="primary"
                disabled={
                  !quiz['clientType'] || 
                  !quiz['contact'] ||
                  showTimer
                }
                onClick={handleStartConfirmation}
              >
                {quiz['contact'] === 'telegram' ? tl('Связаться с ботом') : tl('Получить код')}
              </Button>
            </div>
            {startConfirmationError &&
              <div className={classes.phoneContainerError}>
                {tl('Не удалось отправить код, попробуйте позже')}
              </div>
            }      
            {quiz['phone'] && quiz['phone'].length > 2 && (!quiz['clientType'] || !quiz['contact']) &&
              <div className={classes.phoneContainerError}>
                {!quiz['clientType'] && !quiz['contact'] && tl('Чтобы продолжить выберите, зачем вам платформа и как наш менеджер может связаться с вами')}
                {!quiz['clientType'] && quiz['contact'] && tl('Чтобы продолжить укажите, зачем вам платформа')}
                {quiz['clientType'] && !quiz['contact'] && tl('Чтобы продолжить, выберите как наш менеджер может связаться с вами')}
              </div>
            }
          </div>

          {showSkip &&
            <Button 
              id="welcome-submit-without-phone"
              type="button"
              className={classNames(classes.formBtnCentered, classes.bMargin)}
              variant="text" color="primary" 
              disabled={
                !quiz['clientType'] || 
                !quiz['contact']
              }
              onClick={handleFormWithoutPhone}
            >
              {(quiz['contact'] === 'call' || quiz['contact'] === 'whatsapp') &&
                tl("Я добавлю номер телефона позже")
              }
              {quiz['contact'] === 'telegram' &&
                tl("Я добавлю логин позже")
              }
            </Button>
          }
          </>
        }
        {step === 'confirm' && quiz['contact'] !== 'telegram' &&
          <>
            <h3 className={classes.h3}>{tl('Введите полученный код')}</h3>
            <div className={classes.phoneBlock}>
              <TextField
                variant="outlined"
                fullWidth
                placeholder={tl('Введите код')}
                error={codeError}
                helperText={codeError && tl('Неправильный код')}
                value={code}
                onChange={(event) => {
                  setCode(event.target.value);
                }}
              />
              <Button 
                id="confirm"
                type="submit"
                className={classes.rowFormBtn}
                variant="contained"
                color="primary"
                disabled={!code}
              >
                {tl('Подтвердить')}
              </Button>
            </div>
            {startConfirmationError &&
              <div className={classes.phoneContainerError}>
                {tl('Не удалось отправить код, попробуйте позже')}
              </div>
            }
            {!showTimer &&
              <Button 
                id="send-sms"
                type="button"
                className={classNames(classes.formBtnCentered, classes.bMargin)}
                variant="contained"
                color="primary"
                disabled={
                  showTimer
                }
                onClick={handleStartConfirmation}
              >
                {tl('Я не получил код')}
              </Button>
            }
            {!showTimer &&
              <span className={classes.anotherPhoneNumber} onClick={handleFormWithoutPhone}>
                {tl('Я добавлю номер позже')}
              </span>
            }
            {showTimer &&
              <div className={classes.timer}>
                {tl('Повторная отправка возможна через')}
                {' '}
                <CountdownTimer 
                  interval={retryTimeout}
                  onEnd={() => {
                    setShowTimer(false);
                  }}
                />
                {' '}
                {tl('секунд')}
              </div>
            }
            <span 
              className={classes.anotherPhoneNumber}
              onClick={() => {
                setStep('check');
                setShowTimer(false);
                setRetryTimeout(60);
              }}
            >
              {tl('Ввести другой номер')}
            </span>
          </>
        }
        {step === 'confirm' && quiz['contact'] === 'telegram' &&
          <>
            <h3 className={classes.h3}>{tl('Подтверждение телеграм')}</h3>
            {!telegramConfirmationError &&
              <span>{tl('Напишите что-нибудь боту и проверьте авторизацию')}</span>
            }
            {telegramConfirmationError &&
              <span className={classes.telegramConfirmationError}>{tl('Авторизация не подтвердилась. Попробуйте через пару секунд еще раз')}</span>
            }
            <div className={classes.phoneBlock}>
              <Button 
                id="confirm"
                type="button"
                className={classes.rowFormBtn}
                variant="contained"
                color="primary"
                onClick={handleConfirmTelegram}
              >
                {tl('Подтвердить')}
              </Button>
            </div>
            <span 
              className={classes.anotherPhoneNumber}
              onClick={() => {
                setStep('check');
              }}
            >
              {tl('Сменить способ подтверждения')}
            </span>
          </>
        }
      </div>
    </form>
  )
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: 'auto',
    [theme.breakpoints.down('sm')]: {
      padding: 20,
    }
  },
  mobile: {
    display: 'none',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
    }
  },
  desktop: {
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    }
  },
  videoBlock: {
    display: 'flex',
    flexDirection: 'row',
  },
  videoDescription: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flex: '1 1 60%',
    fontSize: 20,
    lineHeight: '24px',
    fontFamily: 'SF UI Text,sans-serif',
    fontWeight: 400,
  },
  videoWrapper: {
    width: 588,
    height: 330,
    position: 'relative',
    borderRadius: 4,
    overflow: 'hidden',
    [theme.breakpoints.down('sm')]: {
      width: 296,
      height: 166,
    }
  },
  iframeVideo: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
  },
  surveyColumns: {
    display: 'flex',
    flexDirection: 'row',
    gap: 24,
    marginTop: 40,
    marginBottom: 40,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      marginTop: 24,
      marginBottom: 24,
    }
  },
  roundedBlock: {
    background: '#FFFFFF',
    boxShadow: "0px 20px 40px rgba(0, 0, 0, 0.1)",
    borderRadius: 12,
    flex: 1,
  },
  h2: {
    fontSize: 36,
    lineHeight: '40px',
    fontFamily: 'SF UI Text,sans-serif',
    fontWeight: 700,
    marginBottom: 20,   
  },
  h3: {
    fontSize: 20,
    fontFamily: 'SF UI Text,sans-serif',
    textAlign: 'center',
    fontWeight: 'bold',
    marginBottom: 20,
  },
  p: {
    fontSize: 16,
    lineHeight: '19px',
    fontFamily: 'SF UI Text,sans-serif',
    fontWeight: 'normal',
    margin: 0,
  },
  boxPadding1: {
    padding: 20,
  },
  radioLabel: {
    fontSize: 16,
    lineHeight: '19px',
  },
  textField: {
    minWidth: 232,

    '& .MuiInputBase-root': {
      lineHeight: '14px',
    }
  },
  radioLabelContainer: {
    display: 'flex',
  },
  radioGroup: {
    gap: 12,
    marginTop: 20,
  },
  boxPadding2: {
    padding: 24,
  },
  pMargin: {
    marginLeft: 6,
    marginRight: 6,
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
      marginRight: 0,
    }
  },
  bMargin: {
    marginTop: 20,
  },
  rowFormBtn: {
    alignSelf: 'flex-start',
    minWidth: 147,
    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },
  },
  formBtn: {
    alignSelf: 'flex-start',
    minWidth: 147,
    [theme.breakpoints.down('sm')]: {
      marginTop: 20,
      width: '100%',
    },
  },
  formBtnCentered: {
    alignSelf: 'center',
    minWidth: 147,
    [theme.breakpoints.down('sm')]: {
      marginTop: 20,
      width: '100%',
    }
  },
  heightBlock: {
    height: 57,
    [theme.breakpoints.down('sm')]: {
      height: 'auto',
    }
  },
  phoneSection: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '24px 60px',
    [theme.breakpoints.down('sm')]: {
      padding: 20,
    }
  },
  phoneBlock: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    gap: 20,
    marginTop: 20,
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
    },
  },
  phoneContainer: {
    display: 'flex',
    flexDirection: 'column',

  },
  phone: {
    width: 275,

    [theme.breakpoints.down('sm')]: {
      height: 'unset',
    }
  },
  phoneContainerError: {
    fontFamily: 'SF UI Text,sans-serif',
    fontSize: 14,
    fontWeight: 400,
    marginTop: 20,
    color: '#E35248',
    textAlign: 'center',
  },
  telegramConfirmationError: {
    color: 'red',
  },
  timer: {
    color: '#6d6d6d',
    marginTop: 10,
    fontSize: 13,
    lineHeight: '13px',
  },
  anotherPhoneNumber: {
    fontSize: 13,
    lineHeight: '13px',
    fontWeight: 400,
    marginTop: 10,
    color: theme.palette.primary.main,
    textAlign: 'center',
    cursor: 'pointer',
  },
  tourContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4
  },
  tourTitle: {
    fontFamily: 'SF UI Text,sans-serif',
    fontSize: 16,
    fontWeight: 700
  },
  tourBanner: {
    display: 'flex',
    flexDirection: 'row',
    gap: 8,
    padding: 12,
    marginTop: 64,
    [theme.breakpoints.down('sm')]: {
      marginTop: 32,
    }
  },
  tourBannerImage: {
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    }
  },
  tourBannerContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 8,
  },
  tourBannerTitle: {
    fontFamily: 'SF UI Text,sans-serif',
    fontSize: 20,
    fontWeight: 700,
    color: theme.palette.primary.main
  },
  tourBannerDescription: {
    fontFamily: 'SF UI Text,sans-serif',
    fontSize: 15,
    fontWeight: 500,
    color: theme.palette.primary.main
  },
}))


const renderEmbedWelcome = function() {
  return (
    <ThemeProvider theme={Theme}>
        <WelcomePage />
    </ThemeProvider>
  )
}

export default renderEmbedWelcome;